module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-1.7c5fddcd.svg";